import type { Example } from '../types';

export const parameterTypesExample: Example = {
  id: 'parameter-types',
  title: 'Core Parameter Types',
  categoryId: 'parameters',
  description: 'Slider, dropdown, boolean, color picker — the essential widgets',
  scadCode: `/* Core Parameter Types */

// markdown:tip
// **Core Parameter Types** — Meshpit automatically maps your OpenSCAD variables
// to the right input widget based on how you annotate them.
// Try every control below and watch the model update in real time.

/* [Shape] */

// Shape
shape = "cube"; // [cube, sphere, cylinder]

// Size
size = 40; // [10:1:80]

// Hollow?
hollow = true;

// Wall thickness
wall = 4; // [1:0.5:10] {hollow == true}

/* [Appearance] */

// Color
// color
body_color = [0.2, 0.5, 0.9];

// Resolution
$fn = 64; // [16, 32, 64, 128]

// --- parameters end ---

module make_shape(s) {
  if (shape == "cube")     cube([s, s, s], center=true);
  else if (shape == "sphere") sphere(r=s/2);
  else                     cylinder(d=s, h=s, center=true);
}

color(body_color)
if (hollow) {
  difference() {
    make_shape(size);
    make_shape(size - wall * 2);
  }
} else {
  make_shape(size);
}
`,
};
